var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { Api } from "../../../constants/modules/api.constants";
import { RequestClient } from "../../basics/request-client.service";
import { toNative, toNativeVoid } from "../../../utilities/promise-utils";
var GamePlayerTicketClientService = /** @class */ (function () {
    function GamePlayerTicketClientService(requestClient) {
        this.requestClient = requestClient;
    }
    GamePlayerTicketClientService.prototype.purchaseTickets = function (request) {
        return toNative(this.requestClient.post(Api.Client.PurchaseTickets, {}, request));
    };
    GamePlayerTicketClientService.prototype.purchaseInstantGameTickets = function (numberOfDraws, instantGameId) {
        return toNative(this.requestClient.post(Api.Client.PurchaseInstantGameTickets + "/" + instantGameId + "/" + numberOfDraws, {}, {}));
    };
    GamePlayerTicketClientService.prototype.addTicketsToCart = function (request) {
        return toNativeVoid(this.requestClient.post(Api.Client.AddTicketsToCart, {}, request));
    };
    GamePlayerTicketClientService.prototype.createOrModifyTicket = function (request) {
        return toNative(this.requestClient.post(Api.Client.CreateOrModifyTicket, {}, request));
    };
    GamePlayerTicketClientService.prototype.createOrModifyTicketBulk = function (requests) {
        return toNative(this.requestClient.post(Api.Client.CreateOrModifyTicketBulk, {}, {
            requests: requests
        }));
    };
    GamePlayerTicketClientService.prototype.deleteTicket = function (request) {
        return toNativeVoid(this.requestClient.post(Api.Client.DeleteTicket, {}, request));
    };
    GamePlayerTicketClientService.prototype.getSavedTickets = function (request) {
        return toNative(this.requestClient.get(Api.Client.GetSavedTickets, request));
    };
    GamePlayerTicketClientService.prototype.getBundleSavedTickets = function (request) {
        return toNative(this.requestClient.get(Api.Client.GetBundleSavedTickets, request));
    };
    GamePlayerTicketClientService.prototype.getCart = function (lotteryId) {
        return toNative(this.requestClient.get(Api.Client.GetCart, { lotteryId: lotteryId }));
    };
    GamePlayerTicketClientService.prototype.getCartCount = function () {
        return toNative(this.requestClient.get(Api.Client.GetCartCount, {}));
    };
    GamePlayerTicketClientService.prototype.getPurchasesNotificationCount = function () {
        return toNative(this.requestClient.get(Api.Client.GetPurchasesNotificationCount, {}));
    };
    GamePlayerTicketClientService.prototype.removeCartItem = function (cartGuid, brandLotteryId) {
        return toNativeVoid(this.requestClient.post(Api.Client.RemoveCartItem, {}, {
            cartGuid: cartGuid,
            brandLotteryId: brandLotteryId
        }));
    };
    GamePlayerTicketClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient])
    ], GamePlayerTicketClientService);
    return GamePlayerTicketClientService;
}());
export { GamePlayerTicketClientService };
